<template>
  <div id="product">
    <!-- 导航1 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容2 -->
    <div class="content">
      <!-- 搜索框sel2.1 -->
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="搜索">
          <el-input v-model="key" placeholder="请输入关键词"></el-input>
        </el-form-item>
        <el-form-item label="分类">
          <el-select
            v-model="query.type"
            placeholder="请选择产品分类"
            filterable
            clearable
            @change="selSel()"
          >
            <el-option
              v-for="item in roList"
              :label="item.cateName"
              :value="item.id"
              :key="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selSel()">查询</el-button>
          <el-button
            type="success"
            @click="
              dialogVisible = true;
              form = { isVisible: true };
            "
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 列表框2.2 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>产品列表</span>
        </div>
        <!-- <el-tabs v-model="query.type" @tab-click="getList">
            <el-tab-pane
              v-for="item in typeSelList"
              :label="item.name"
              :key="item.id"
              :name="item.id.toString()"
            ></el-tab-pane>
          </el-tabs> -->
        <!-- 列表 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
          @sort-change="sortChange"
          @filter-change="filterTag"
        >
          <el-table-column prop="name" label="名称">
            <template slot-scope="scope">
              <a :href="scope.row.linkUrl" target="_blank">{{
                scope.row.name
              }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="priceSell" label="销售价"></el-table-column>
          <el-table-column
            prop="priceOriginal"
            label="市场价"
          ></el-table-column>
          <el-table-column prop="sort" label="排序"></el-table-column>
          <el-table-column
            prop="proCate.cateName"
            label="所属分类"
          ></el-table-column>
          <el-table-column prop="isEnable" label="是否上架">
            <template slot-scope="sc">
              <el-tag v-if="sc.row.isEnable" type="success">是</el-tag>
              <el-tag v-else type="warn">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="isRecommend" label="是否推荐">
            <template slot-scope="sc">
              <el-tag v-if="sc.row.isRecommend" type="success">是</el-tag>
              <el-tag v-else type="warn">否</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="创建日期"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-tooltip content="编辑" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editClick(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button
                  type="danger"
                  size="mini"
                  icon="el-icon-delete"
                  @click="delClick(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页条page -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-size="pageSize"
            :page-sizes="[10, 20, 30, 50, 100]"
            layout="total,prev,sizes,pager,next,jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>
    <!-- 操作对话框3 -->
    <el-dialog
      :title="form.id > 0 ? '编辑产品' : '添加产品'"
      :visible.sync="dialogVisible"
      @opened="dialogOpened()"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="100px"
        :status-icon="true"
        @submit.native.prevent="submitForm(form)"
        
      >
        <!-- 内容3.1 -->
        <el-form-item
          label="名称"
          prop="name"
          :rules="[{ required: true, message: '请输入名称,最多30个字' }]"
        >
          <el-input v-model="form.name" placeholder="请输入名称"></el-input>
        </el-form-item>
        <!-- 图片框 -->
        <el-form-item
          label="图片"
          prop="imgUrl"
          :rules="[{ required: true, message: '不能为空' }]"
        >
          <div id="uploadBtn1" class="uploader uploader-warning"></div>
          <img
            id="relativeName"
            :src="domain + form.imgUrl"
            style="height: 40px; position: relative; left: 10px; top: 20px"
            v-if="form.imgUrl"
          />
        </el-form-item>
        <el-form-item
          label="销售价"
          prop="priceSell"
          :rules="[{ required: true, message: '不能为空' }]"
        >
          <el-input
            v-model="form.priceSell"
            placeholder="请输入价格"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="市场价"
          prop="priceOriginal"
          :rules="[{ required: false }]"
        >
          <el-input
            v-model="form.priceOriginal"
            placeholder="请输入价格"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="排序"
          prop="sort"
          :rules="[{ type: 'number', message: '请填写数字' }]"
        >
          <el-input
            v-model.number="form.sort"
            placeholder="请输入排序字段"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="产品详情"
          prop="content"
          :rules="[{ required: true, message: '请输入产品详情' }]"
        >
          <div style="position: relative">
            <vue-ueditor-wrap
              v-model="form.content"
              :config="editorConfig"
            ></vue-ueditor-wrap>
          </div>
        </el-form-item>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              label="所属分类"
              prop="type"
              :rules="[{ required: true, message: '请选择所属分类' }]"
            >
              <el-select
                v-model="form.type"
                placeholder="请选择所属分类"
                filterable
              >
                <el-option
                  v-for="item in roList"
                  :label="item.cateName"
                  :value="item.id"
                  :key="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- 布尔选择框 -->
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="是否上架">
              <el-switch v-model="form.isEnable"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="6">
            <el-form-item label="是否推荐">
              <el-switch v-model="form.isRecommend"></el-switch>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="dialogVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import url from "@/plugins/urlHelper.js";
import VueUeditorWrap from "vue-ueditor-wrap";

export default {
  name: "product",
  components: { VueUeditorWrap },
  data() {
    return {
      key: "",
      domain: url.getDomain(),
      query: {},
      form: {},
      tableData: [],
      total: 0,
      dialogVisible: false,
      loading: false,
      submiting: false,
      currentPage4: 1,
      pageSize: 10,
      typeSelList: [],
      roList: [], //角色列表
      editorConfig: {
        serverUrl: url.getUE(),
        UEDITOR_HOME_URL: url.getUEConfig(),
        initialFrameWidth: "100%",
        initialFrameHeight: 500,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    handleSizeChange: function (val) {
      this.pageSize = val;
      this.currentPage4=1;
      this.getList();
    },
    handleCurrentChange: function (val) {
      this.currentPage4 = val;
      this.getList();
    },
    // 排序
    sortChange: function (sortColumn) {
      this.query.sort = sortColumn.sort;
      this.query.order = sortColumn.order;
      this.getList();
    },
    // 筛选
    filterTag: function (filter) {
      var val = filter["isEnable"][0];
      this.getList();
    },
    //查询
    selSel() {
      this.currentPage4 = 1;
      this.getList();
    },
    // 新增
    addClick() {
      this.dialogVisible = true;
      this.form = {
        isEnable: true,
      };
    },
    //列表方法
    getList() {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      params.key = _this.key;
      var link = url.getSys("getlist_product");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    roleList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageSize = _this.pageSize;
      params.pageIndex = _this.currentPage4;
      params.key = _this.key;
      var link = url.getSys("getlist_proCate");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.roList = data.list;
      });
    },
    // 修改
    editClick(row) {
      var id=row.id;
      var link=url.getSys("GetModel_Product");
      $.post(link,{ids:id},(res)=>{
        this.form=res;
      });
      this.form = Object.assign({}, row);
      this.dialogVisible = true;
    },
    // 删除
    delClick(row) {
      var _this = this;
      var link = url.getSys("delete_product");
      var id = row.id;

      this.$confirm("确定删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { ids: id }, (res) => {
            if (res.status) {
              _this.getList();

              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: "删除失败!",
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除!",
          });
        });
    },
    //上传图片
    dialogOpened: function () {
      var _this = this;

      if ($("#uploadBtn1 input").length == 0) {
        $("#uploadBtn1").uploader({
          url: url.getUpload(),
          fileExts: "jpg;png",
          type: "dialog",
          text: "剪切图片模式",
          more: false,
          auto: true,
          maxSize: 1024 * 1024 * 1, //文件最大大小，单位字节
          coverParams: {
            title: "设置产品图片",
            targetWidth: 300,
            targetHeight: 410,
          },
          onSuccess: function (data) {
            var src = url.getDomain() + data.relativeName;
            _this.$set(_this.form, "imgUrl", data.relativeName);
          },
        });
      }
    },
    // 提交
    submitForm(formName) {
      var _this = this;
      var link = url.getSys("addOrUpdate_product");
      var info = this.form;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({ type: "success", message: res.msg });
            } else {
              _this.$message({ type: "error", message: res.msg });
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  mounted() {
    //获取服务器列表
    this.getList();
    //获取角色列表
    this.roleList();
  },
};
</script>